import React from "react";
import Page from "../../components/Page";
import Configuration from "../../config";

/**
 * Komponente um statische Inhalte auszugeben
 */
class Imprint extends React.Component
{
	render()
	{
		return <Page title={"Impressum"} pageUrl={"/impressum"}>
			<section className={"white"}>
				<h3>Gesetzliche Anbieterkennung</h3>
				<h3>Handelsregister</h3>
				<p>
					Registergericht: Amtsgericht Siegburg<br/> Registernummer: HRB 6765
				</p>
				<h3>
					Geschäftsführer</h3>
				<p>
					Dipl.-Inf. Michael Strucken, Dipl.-SpOec. Daniel Jakob, Dipl.-Volksw. Markus Jakob
				</p>
				<h3>
					Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz
				</h3>
				<p>DE123370531
				</p>
				<h3>
					Inhaltlich Verantwortlicher gemäß § 55 Abs. 2 RStV
				</h3>
				<p>
					Dipl.-Volksw. Markus Jakob<br/>
					(Anschrift wie oben)
				</p>
				<h3>
					Urheberrecht und Bildnachweise
				</h3>
				<p>Die Inhalte von <a href={Configuration.publicUrl} target="_self">{Configuration.publicUrl}</a> sind - soweit nicht abweichend angegeben -
					urheberrechtlich geschützt. Verwendete Fotografien sind ggf. mit Bildnachweisen gekennzeichnet oder unten aufgeführt, soweit sie nicht selbst
					angefertigt wurden. Die Verwendung von Fotografien auf Drittseiten ist nur im Rahmen der jeweiligen Lizenz der Urheber möglich.
				</p>
			</section>
		</Page>;
		
	} // function render()
	
} // class

export default Imprint;